











import Vue, {VueConstructor} from 'vue'
import {
  USER_ROLE_ADMIN,
  USER_ROLE_ADMIN_LABEL,
  USER_ROLE_MAILING,
  USER_ROLE_MAILING_LABEL,
  USER_ROLE_STATS,
  USER_ROLE_STATS_LABEL,
  USER_ROLE_STUD,
  USER_ROLE_STUD_LABEL,
  USER_ROLE_WIKI,
  USER_ROLE_WIKI_LABEL,
  USER_ROLE_STUDAUTH,
  USER_ROLE_STUDAUTH_LABEL,
  USER_ROLE_CHAT,
  USER_ROLE_CHAT_LABEL,
  USER_ROLE_STUDREMOVE,
  USER_ROLE_STUDREMOVE_LABEL
} from '@/constants';


interface IRole {
  label: string,
  code: string,
  value: boolean
}

export default (Vue as VueConstructor<Vue & {

}>).extend({
  name: 'rolesSwitcher',
  props: {
    value: {
      type: Array as () => string[],
      default: []
    }
  },
  data () {
    return {
      roles: [
        {label: USER_ROLE_ADMIN_LABEL, code: USER_ROLE_ADMIN, value: false},
        {label: USER_ROLE_MAILING_LABEL, code: USER_ROLE_MAILING, value: false},
        {label: USER_ROLE_STATS_LABEL, code: USER_ROLE_STATS, value: false},
        {label: USER_ROLE_STUD_LABEL, code: USER_ROLE_STUD, value: false},
        {label: USER_ROLE_WIKI_LABEL, code: USER_ROLE_WIKI, value: false},
        {label: USER_ROLE_STUDAUTH_LABEL, code: USER_ROLE_STUDAUTH, value: false},
        {label: USER_ROLE_STUDREMOVE_LABEL, code: USER_ROLE_STUDREMOVE, value: false},
        {label: USER_ROLE_CHAT_LABEL, code: USER_ROLE_CHAT, value: false}
      ] as IRole[],
      checked: [] as string[]
    }
  },
  methods: {
    setDefault (): void {
      if (this.value && Array.isArray(this.value)) {
        for (const role of this.value) {
          let index = this.findRole(role);
          if (typeof index === 'number') {
            this.roles[index].value = true;
          } else {
            console.error('Unknow role!', role)
          }
        }
      } else {
        console.error('Roles must be Array, got ', this.value)
      }
    },
    findRole (neededRole: string): number | false {
      let index: number | boolean = false;
      this.roles.forEach(function (role: IRole, i: number) {
        if (role.code === neededRole) {
          index = i;
        }
      });
      return index;
    },
    setChecked (): void {
      let checked: string[] = [];
      for (const role of this.roles) {
        if (role.value) {
          checked.push(role.code as string)
        }
      }
      this.checked = checked;
      this.onInput();
    },
    onInput (): void {
      this.$emit('input', this.checked)
    }
  },
  mounted () {
    this.setDefault();
  }
})
